export default function formatarDTA(dta) {
    dta = dta.replace(/[^\d]+/g, '');
    let dtaAtualizado;
    dtaAtualizado = dta.replace(/(\d{2})(\d{7})(\d{1})/,
        function (regex, argumento1, argumento2, argumento3) {
            return argumento1 + '/' + argumento2 + '-' + argumento3;
        });
    return dtaAtualizado;
}